import { describe, expect,it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  COMPANY_FIELDS,
  CONTACT_FIELDS,
  CONTACT_SAME_AS_FIELDS,
  DELIVERY_DETAILS_FIELDS,
  DELIVERY_INSTRUCTIONS_FIELDS,
  SOLD_TO_ADDRESS_FIELDS} from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages from '..';

describe('Company Page Template', () => {
  it('exports pages array', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages.length).toBe(2);
  });

  const companyPage = pages.find(p => p.route === PAGE_ROUTES.company);
  const reviewPage = pages.find(p => p.route === PAGE_ROUTES.review);

  describe('Company Page Structure', () => {
    it('has correct route and component', () => {
      expect(companyPage).toBeDefined();
      expect(companyPage?.route).toBe(PAGE_ROUTES.company);
      expect(companyPage?.Component).toBeDefined();
    });

    it('contains expected cards', () => {
      expect(Array.isArray(companyPage?.cards)).toBe(true);
      expect(companyPage?.cards).toHaveLength(8); // company, soldTo, deliveryDetails, deliveryInstructions, coa, orderConfirmation, attachment, privacy
    });
  });

  describe('Company Card', () => {
    const companyCard = companyPage?.cards?.find(c => c.key === CARD_CATEGORIES.company);

    it('has correct fields', () => {
      expect(companyCard?.fields?.map(f => f.key)).toEqual([
        COMPANY_FIELDS.tradeDbaName,
        COMPANY_FIELDS.legalName,
        COMPANY_FIELDS.parentCompany
      ]);
    });
  });

  describe('SoldTo Card', () => {
    const soldToCard = companyPage?.cards?.find(c => c.key === CARD_CATEGORIES.soldTo);

    it('has required fields and errorMustContain', () => {
      const requiredKeys = soldToCard?.fields?.filter(f => f.required).map(f => f.key);
      expect(requiredKeys).toEqual([
        SOLD_TO_ADDRESS_FIELDS.email,
        SOLD_TO_ADDRESS_FIELDS.icmsTaxPayer,
        SOLD_TO_ADDRESS_FIELDS.telephone1
      ]);
      expect(soldToCard?.errorMustContain).toBe('address');
    });
  });

  describe('Delivery Details & Instructions Cards', () => {
    const deliveryDetails = companyPage?.cards?.find(c => c.key === CARD_CATEGORIES.deliveryDetails);
    const deliveryInstructions = companyPage?.cards?.find(c => c.key === CARD_CATEGORIES.deliveryInstructions);

    it('deliveryDetails has correct fields', () => {
      expect(deliveryDetails?.fields?.map(f => f.key)).toEqual([
        DELIVERY_DETAILS_FIELDS.appointmentRequired,
        DELIVERY_DETAILS_FIELDS.receivingPlantContactName,
        DELIVERY_DETAILS_FIELDS.receivingPlantPhoneNumber,
        DELIVERY_DETAILS_FIELDS.afterHoursContactName,
        DELIVERY_DETAILS_FIELDS.afterHoursPhoneNumber,
        DELIVERY_DETAILS_FIELDS.warehouseReceivingHours
      ]);
      expect(deliveryDetails?.fieldWrapper).toBe(CARD_CATEGORIES.shipTo + '[0]');
    });

    it('deliveryInstructions has correct fields', () => {
      expect(deliveryInstructions?.fields?.map(f => f.key)).toEqual([
        DELIVERY_INSTRUCTIONS_FIELDS.shippingInstructions,
        DELIVERY_INSTRUCTIONS_FIELDS.shippingMarks,
        DELIVERY_INSTRUCTIONS_FIELDS.customsText,
        DELIVERY_INSTRUCTIONS_FIELDS.loadingInstructions,
        DELIVERY_INSTRUCTIONS_FIELDS.unloadingInstructions,
        DELIVERY_INSTRUCTIONS_FIELDS.packingInstructions,
        DELIVERY_INSTRUCTIONS_FIELDS.billOfLadingText,
        DELIVERY_INSTRUCTIONS_FIELDS.textNotaFiscal
      ]);
      expect(deliveryInstructions?.fieldWrapper).toBe(CARD_CATEGORIES.shipTo);
    });
  });

  describe('COA & Order Confirmation Cards', () => {
    const coaCard = companyPage?.cards?.find(c => c.key === CARD_CATEGORIES.coa);
    const orderCard = companyPage?.cards?.find(c => c.key === CARD_CATEGORIES.orderConfirmation);

    it('COA card has correct fields and sameAsFields', () => {
      expect(coaCard?.fields?.map(f => f.key)).toEqual([
        CONTACT_FIELDS.email,
        CONTACT_FIELDS.fax
      ]);
      expect(coaCard?.sameAsFields).toEqual([CONTACT_SAME_AS_FIELDS.sameAsInvoiceDelivery]);
    });

    it('Order Confirmation card has correct fields and sameAsFields', () => {
      expect(orderCard?.fields?.map(f => f.key)).toEqual([
        CONTACT_FIELDS.email,
        CONTACT_FIELDS.fax
      ]);
      expect(orderCard?.sameAsFields).toEqual([
        CONTACT_SAME_AS_FIELDS.sameAsInvoiceDelivery,
        CONTACT_SAME_AS_FIELDS.sameAsCoa,
        CONTACT_SAME_AS_FIELDS.sameAsPackingList
      ]);
    });
  });

  describe('Attachment & Privacy Cards', () => {
    it('contains additionalAttachmentCard', () => {
      const attachmentCard = companyPage?.cards?.find(c => c.key === CARD_CATEGORIES.additionalAttachmentCard);
      expect(attachmentCard?.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = companyPage?.cards?.find(c => c.key === CARD_CATEGORIES.privacyPolicy);
      expect(privacyCard?.fields).toBeUndefined();
    });
  });

  describe('Review Page Structure', () => {
    it('has correct route and component', () => {
      expect(reviewPage?.route).toBe(PAGE_ROUTES.review);
      expect(reviewPage?.Component).toBeDefined();
    });

    it('contains company accordion', () => {
      expect(Array.isArray(reviewPage?.accordions)).toBe(true);
      const companyAccordion = reviewPage?.accordions?.find(a => a.title === 'tabTitles.company');
      expect(companyAccordion?.cards).toEqual(companyPage?.cards);
    });
  });
});